import { inject, Injectable } from '@angular/core';
import { RestApiService } from '@core/services/rest-api.service';
import {
  RouteNetwork,
  RouteNetworkSegmentLine,
} from '@shared/interfaces/route-network';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RouteNetworkDataService {
  private api = inject(RestApiService);

  updateLines(
    routeSegmentLines: RouteNetworkSegmentLine[]
  ): Observable<Partial<RouteNetworkSegmentLine[]>> {
    return this.api.postCustom('Route/UpsertLines', routeSegmentLines);
  }

  getRouteNetworks(): Observable<RouteNetwork[]> {
    return this.api.getCustom<RouteNetwork[]>('Route/MyNetworks');
  }

  deleteLines(ids: number[]): Observable<object> {
    return this.api.deleteCustom('Route/DeleteLines', ids);
  }
}
